import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../models/template/type.enum';
import { TemplateEditorComponent } from '../../base-template-editor/template-editor.component';

@Component({
    selector: 'app-translate-web-push-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [isTranslator]="true"
      [templateType]="templateType"
      templateBasePath="/translate-web-push-template/"
      channelLabel="Web Push"
      namePlaceholder="Enter web push name"
      emptyMessage="No web push found!"
      heartbeatType="web-push"
      [showResponsysButton]="true" />
  `
})
export class TranslateWebPushTemplateComponent {
  protected readonly templateType = TypeEnum.WEBPUSH;
}
